// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatHeaderContainer__NMnaF {
  height: 80px;
}

.chatHeaderRedirect__RHGmL {
  margin: auto 20px auto 5px;
}

.avatarContainer__X4vDB {
  display: flex;
  align-items: center;
  margin: 20px 0 16px 20px;
}

.avatar__J08uY {
  width: 44px;
  height: 44px;
  border-radius: 50%;
}

.name__KRdKg {
  max-width: 200px;
  margin-left: 12px;

  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  color: #fff;
}

.onlineStatusContainer__VtmdF {
  display: flex;
  align-items: center;
  margin-top: 4px;
  margin-left: 12px;
}

.onlineCircle__H3nJc {
  width: 8px;
  height: 8px;
  background-color: #2bef83;
  border-radius: 50%;
}

.onlineText__vaPgz {
  margin-left: 6px;
  font-size: 12px;
  line-height: 16px;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat/ChatHeader/ChatHeader.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb","sourcesContent":[".chatHeaderContainer {\n  height: 80px;\n}\n\n.chatHeaderRedirect {\n  margin: auto 20px auto 5px;\n}\n\n.avatarContainer {\n  display: flex;\n  align-items: center;\n  margin: 20px 0 16px 20px;\n}\n\n.avatar {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n}\n\n.name {\n  max-width: 200px;\n  margin-left: 12px;\n\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 16px;\n  color: #fff;\n}\n\n.onlineStatusContainer {\n  display: flex;\n  align-items: center;\n  margin-top: 4px;\n  margin-left: 12px;\n}\n\n.onlineCircle {\n  width: 8px;\n  height: 8px;\n  background-color: #2bef83;\n  border-radius: 50%;\n}\n\n.onlineText {\n  margin-left: 6px;\n  font-size: 12px;\n  line-height: 16px;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export var chatHeaderContainer = `chatHeaderContainer__NMnaF`;
export var chatHeaderRedirect = `chatHeaderRedirect__RHGmL`;
export var avatarContainer = `avatarContainer__X4vDB`;
export var avatar = `avatar__J08uY`;
export var name = `name__KRdKg`;
export var onlineStatusContainer = `onlineStatusContainer__VtmdF`;
export var onlineCircle = `onlineCircle__H3nJc`;
export var onlineText = `onlineText__vaPgz`;
export default ___CSS_LOADER_EXPORT___;
